export default __webpack_public_path__ + "static/media/Icon feather-arrow-right-circle.80c0345c.svg";